<div class="w-full h-full flex flex-col items-start justify-start animation-fade-in">
    @if (currentUser?.timeZone) {
        <fm-calendar-header
            [scrollBarWidth]="scrollbarWidth()"
            [timezone]="currentUser?.timeZone"
            [startOfWeekDay]="currentUser.settings.startOfWeekDay"
            class="w-full" />
        @if (initialized) {
            <fm-calendar-days
                [days]="days"
                [timezone]="currentUser.timeZone"
                [timeFormat]="currentUser.settings.timeFormat"
                [sessionDuration]="sessionDuration"
                [availableGroupMeetings]="groupMeetingsStoreService.availableGroupMeetingsSig()"
                (updatedScrollbarWidth)="onReceiveScrollbarWidth($event)"
                class="h-[calc(100%_-_52px)] w-full overflow-hidden" />
        }
    }

    @if ((selectedSessionService.selectedSessions$ | async).length) {
        @let length = (selectedSessionService.selectedSessions$ | async).length;
        @let isMobile = viewportService.isMobile();

        @if ((isMobile && length > 1) || !isMobile) {
            <div
                class="w-full h-[75px] border-t border-t-p-content-border-color flex justify-between items-center p-4 gap-4 gb-white">
                <p-button
                    [buttonProps]="{ autofocus: false }"
                    [disabled]="bookingInProgress"
                    (click)="onClickClearAll()"
                    size="large"
                    severity="primary"
                    [outlined]="true"
                    class="flex-1"
                    styleClass="w-full"
                    label="Clear All" />

                <p-button
                    [buttonProps]="{ autofocus: false }"
                    (click)="onClickBookSessions()"
                    [loading]="bookingInProgress"
                    size="large"
                    severity="primary"
                    class="flex-1"
                    styleClass="w-full"
                    [label]="
                        bookingInProgress
                            ? ''
                            : 'Book ' +
                              (length || 0) +
                              ' ' +
                              ((length || 0) === 1 ? 'session' : 'sessions')
                    " />
            </div>
        }
    }
</div>
